<template>
  <div class="layout-container">
    <div class="layout-header">
      <b-container class="d-flex justify-content-between">
        <h1>{{ title }}</h1>
        <slot name="layout-header" />
      </b-container>
    </div>
    <b-container>
      <div class="layout-content pt-2">
        <slot name="layout-content" />
      </div>
    </b-container>
    <template v-if="doubleContent">
      <br>
      <b-container>
        <div class="layout-content pt-2 pb-2">
          <slot name="layout-content-2" />
        </div>
      </b-container>
    </template>
  </div>
</template>

<script>
  // TODO should be moved in src/components
  export default {
    name: 'LayoutComponent',
    props: {
      title: {
        type: String,
        default: null,
      },
      doubleContent: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import 'compass/css3/transform';

  .layout-container {
    .layout-header {
      background-color: $primary;
      padding: 1.5rem 0;
      height: 150px;

      h1 {
        color: $white;
        text-transform: uppercase;
        margin: 0;
        font-size: 1.8rem;
      }
    }

    .layout-content {
      background-color: $white;
      min-height: 100px;
      padding-bottom: 80px;

      @include transform(translateY(-80px));
    }
  }

  @include media-breakpoint-down(md) {
    .layout-container {
      .layout-header {
        height: auto;
      }

      .layout-content {
        @include transform(translateY(0));
      }
    }
  }
</style>
